/**
 * Saved-game persistence in localStorage.
 *
 * The previous AppContainer carried these helpers inline, but with routing
 * each route component that cares about a saved game (the menu's "Resume"
 * affordance, the /play cold-load fallback) needs access without going
 * through React Router context. A standalone module keeps those imports
 * shallow and avoids circular dependencies with the rest of AppContainer.
 *
 * The shape stored under SESSION_STORAGE_KEY:
 *   {
 *     sessionData: { ...App.js-internal restoration payload },
 *     config:      { ...game config the App was started with },
 *     savedAt:     epoch ms,
 *   }
 */

const SESSION_STORAGE_KEY = 'phutball_session';

export function getSavedSession() {
  try {
    const raw = localStorage.getItem(SESSION_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.sessionData && parsed.config) return parsed;
    }
  } catch (e) {
    console.warn('Failed to parse saved session:', e);
  }
  return null;
}

export function saveSession(sessionData, config) {
  try {
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify({
      sessionData,
      config,
      savedAt: Date.now(),
    }));
  } catch (e) {
    console.warn('Failed to save session:', e);
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(SESSION_STORAGE_KEY);
  } catch (e) {
    /* ignore */
  }
}
